/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AcademyLanguage =
  | 'EN'
  | 'DE'
  | 'FR'
  | 'ES'
  | 'JA'
  | 'PT'
  | unhandledEnumCase;

export type ContentContainerType =
  | 'COURSE'
  | 'LESSON'
  | 'TRACK'
  | 'PLAYLIST'
  | 'SHORT_FORM_CONTENT'
  | 'LEARNING_PATH'
  | 'LIVE_EVENT'
  | unhandledEnumCase;

export type LessonStatus =
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'NOT_STARTED'
  | unhandledEnumCase;

export type PlaylistStatus =
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'NOT_STARTED'
  | unhandledEnumCase;

export type ProgressType =
  | 'COMPLETED'
  | 'STARTED'
  | 'IN_REVIEW'
  | 'FAILED'
  | 'NOT_STARTED'
  | unhandledEnumCase;

export type QuizQuestionType =
  | 'MULTIPLE_CHOICE_SELECT_ONE'
  | 'MULTIPLE_CHOICE_SELECT_MANY'
  | unhandledEnumCase;

export type ShortStatus =
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'NOT_STARTED'
  | unhandledEnumCase;

export type SupportedLanguage =
  | 'EN'
  | 'DE'
  | 'FR'
  | 'ES'
  | 'JA'
  | 'PT'
  | unhandledEnumCase;

export type TrackAwardVisibility = 'PUBLIC' | 'PRIVATE' | unhandledEnumCase;

export type TrackStatus =
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'EXPIRING_SOON'
  | 'NOT_STARTED'
  | unhandledEnumCase;

export type UserShortProgressContext =
  | 'INDIVIDUAL'
  | 'PLAYLIST'
  | unhandledEnumCase;

export type UserLessonProgressContext =
  | 'INDIVIDUAL'
  | 'TRACK'
  | 'PLAYLIST'
  | unhandledEnumCase;

export type UserTrackProgressContext =
  | 'INDIVIDUAL'
  | 'PLAYLIST'
  | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type LiveEventStatus =
  | 'NOT_STARTED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | unhandledEnumCase;

export const LessonProgressResponseTypename =
  'com.hubspot.userprogress.bff.rpc.models.LessonProgressResponse';
export type LessonProgressResponse = {
  context: UserLessonProgressContext;
  language?: SupportedLanguage;
  id: number;
  updatedAt: number;
  type: ContentContainerType;
  status: LessonStatus;
  hidden: boolean;
  completedPercentage: number;
  remainingDuration: number;
  __typename: 'com.hubspot.userprogress.bff.rpc.models.LessonProgressResponse';
};

export const LiveEventProgressResponseTypename =
  'com.hubspot.userprogress.bff.rpc.models.LiveEventProgressResponse';
export type LiveEventProgressResponse = {
  id: number;
  updatedAt: number;
  type: ContentContainerType;
  status: LiveEventStatus;
  hidden: boolean;
  completedPercentage: number;
  remainingDuration: number;
  __typename: 'com.hubspot.userprogress.bff.rpc.models.LiveEventProgressResponse';
};

export const PlaylistProgressResponseTypename =
  'com.hubspot.userprogress.bff.rpc.models.PlaylistProgressResponse';
export type PlaylistProgressResponse = {
  completedItemsCount: number;
  id: number;
  updatedAt: number;
  type: ContentContainerType;
  status: PlaylistStatus;
  hidden: boolean;
  completedPercentage: number;
  remainingDuration: number;
  __typename: 'com.hubspot.userprogress.bff.rpc.models.PlaylistProgressResponse';
};

export type ProgressResponse =
  | ShortProgressResponse
  | TrackProgressResponse
  | LessonProgressResponse
  | PlaylistProgressResponse
  | LiveEventProgressResponse;

export const ShortProgressResponseTypename =
  'com.hubspot.userprogress.bff.rpc.models.ShortProgressResponse';
export type ShortProgressResponse = {
  context: UserShortProgressContext;
  language?: SupportedLanguage;
  id: number;
  updatedAt: number;
  type: ContentContainerType;
  status: ShortStatus;
  hidden: boolean;
  completedPercentage: number;
  remainingDuration: number;
  __typename: 'com.hubspot.userprogress.bff.rpc.models.ShortProgressResponse';
};

export type TrackAwardResponse = {
  certificate?: string;
  expiresAt: number;
  isExpired: boolean;
  examAttemptId?: number;
  trackIdAward?: number;
  trackAwardLanguage?: SupportedLanguage;
  awardName: Default<string>;
  awardedAt: Default<number>;
  code: Default<string>;
  renewedAt?: number;
  visibility?: TrackAwardVisibility;
  grantedCredentialId?: number;
};

export const TrackProgressResponseTypename =
  'com.hubspot.userprogress.bff.rpc.models.TrackProgressResponse';
export type TrackProgressResponse = {
  award?: TrackAwardResponse;
  context: UserTrackProgressContext;
  language?: SupportedLanguage;
  /** @deprecated */
  completedLessonIds: Default<number[]>;
  completedLessonCount: Default<number>;
  id: number;
  updatedAt: number;
  type: ContentContainerType;
  status: TrackStatus;
  hidden: boolean;
  completedPercentage: number;
  remainingDuration: number;
  __typename: 'com.hubspot.userprogress.bff.rpc.models.TrackProgressResponse';
};

export type UserProgressCollectionRequest = {
  requestedProgress: Default<UserProgressRequest[]>;
  includePlaylistRemainingDuration: Default<boolean>;
};

export type UserProgressCollectionResponse = {
  progress: Default<ProgressResponse[]>;
};

export type UserProgressError = {
  errorType: ComHubspotUserprogressBffRpcModelsAbstractUserProgressError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type UserProgressRequest = {
  id: number;
  type: ContentContainerType;
  language?: SupportedLanguage;
};

export namespace ComHubspotUserprogressBffRpcModelsAbstractUserProgressError {
  export type ErrorType =
    | 'INVALID_ENUM_VALUE'
    | 'MISSING_USER_ID'
    | 'NA1_PROXY_FAILED'
    | 'HUBLET_MISSING_FROM_CHIRP_CONTEXT'
    | unhandledEnumCase;
}

export type AcademyUserProgressV2Response = {
  contentProgress: Default<Record<string, BasicProgress>>;
  assetProgress: Default<AssetProgressResponse[]>;
};

export type AssetContentProgressResponse = {
  contentId: number;
  progressType: ProgressType;
  updatedAt: number;
};

export type AssetProgressResponse = {
  id: Default<number>;
  updatedAt: number;
  type: ContentContainerType;
  status: string;
  hidden: boolean;
  award?: TrackAward;
  context?: string;
  language?: SupportedLanguage;
};

export type BasicProgress = {
  updatedAt: number;
  duration: number;
  type: ProgressType;
  completed: boolean;
};

export type ExamAttempt = {
  id: Default<number>;
  contentId: number;
  language: SupportedLanguage;
  userId: number;
  portalId: Default<number>;
  attemptStartTime: number;
  passThreshold: number;
  attemptFinishTime?: number;
  attemptRetakeTime?: number;
  expired?: boolean;
  questions: Default<QuizQuestion[]>;
  questionSubmissions: Default<QuestionSubmission[]>;
  questionIds: Default<number[]>;
  passed: Default<boolean>;
  score: Default<number>;
  examId: number;
  finished: Default<boolean>;
};

export type GetLessonProgressRequest = { lessonId: number };

export type GetTrackProgressRequest = {
  trackId: number;
  includeExpiredAwards: Default<boolean>;
};

export type GetUserProgressRequest = { language: SupportedLanguage };

export type LessonContentProgressResponse = {
  lessonId: number;
  status: LessonStatus;
  updatedAt?: number;
  contentProgress: Default<AssetContentProgressResponse[]>;
  quizIdToRecentAttemptId: Default<Record<string, number>>;
  quizAttempts: Default<Record<string, QuizAttempt>>;
  language?: SupportedLanguage;
  progressLevel: Default<number>;
};

export type QuestionSubmission = {
  questionId: number;
  answerIds: Default<number[]>;
};

export type QuizAnswer = {
  id: Default<number>;
  questionId: number;
  text: string;
  displayOrder?: number;
  correct?: boolean;
};

export type QuizAnswerSubmission = {
  id: number;
  quizAttemptId: number;
  questionId: number;
  correctAnswer: boolean;
  submissionTime: number;
  answerIds: Default<number[]>;
};

export type QuizAttempt = {
  id: number;
  language: AcademyLanguage;
  contentId: number;
  userId: number;
  portalId: number;
  attemptStartTime: number;
  attemptFinishTime?: number;
  passed?: boolean;
  answerSubmissions: Default<QuizAnswerSubmission[]>;
};

export type QuizQuestion = {
  id: number;
  contentId?: number;
  displayOrder?: number;
  question: string;
  questionType: QuizQuestionType;
  correctResponse: string;
  partiallyCorrectResponse?: string;
  incorrectResponse: string;
  answers: Default<QuizAnswer[]>;
  image?: string;
  language?: SupportedLanguage;
  imageAlt?: string;
};

export type TrackAward = {
  awardName: string;
  userId: number;
  examAttemptId?: number;
  certificate?: string;
  badge?: string;
  code: string;
  awardedAt: number;
  expiresAt: number;
  renewedAt?: number;
  visibility?: TrackAwardVisibility;
  trackId?: number;
  trackIdAward?: number;
  grantedCredentialId?: number;
};

export type TrackContentProgressAwardResponse = {
  trackId?: number;
  awardName: string;
  userId: number;
  examAttemptId?: number;
  certificate?: string;
  badge?: string;
  code: string;
  awardedAt: number;
  expiresAt: number;
  renewedAt?: number;
  visibility?: TrackAwardVisibility;
  trackIdAward?: number;
  trackAwardLanguage?: SupportedLanguage;
  grantedCredentialId?: number;
};

export type TrackContentProgressResponse = {
  trackId: number;
  status: TrackStatus;
  updatedAt?: number;
  introVideoProgress?: AssetContentProgressResponse;
  examAttempts: Default<Record<string, ExamAttempt>>;
  examIdToRecentAttemptId: Default<Record<string, number>>;
  progress: Default<LessonContentProgressResponse[]>;
  language?: SupportedLanguage;
  trackAward?: TrackContentProgressAwardResponse;
  progressLevel: Default<number>;
};

export type UserProgressReadError = {
  errorType: ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export namespace ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError {
  export type ErrorType =
    | 'NOT_FOUND'
    | 'INVALID_REQUEST'
    | 'MISSING_USER_ID'
    | 'NA1_PROXY_FAILED'
    | 'HUBLET_MISSING_FROM_CHIRP_CONTEXT'
    | unhandledEnumCase;
}

export type GetUserProgressRequestType =
  Requestify<UserProgressCollectionRequest>;
export type GetUserProgressResponseType = UserProgressCollectionResponse;
export type GetUserProgressErrorType = UserProgressError & HubspotMetadata;
export const getUserProgressRpc: ChirpAvroRpcDetails<
  GetUserProgressRequestType,
  GetUserProgressResponseType,
  GetUserProgressErrorType,
  false
> = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserProgress',
  auth: 'app',
  fingerprint: 'EyWYBYoafJhirP1HAqYtYq4AvDvBA3a6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUserLessonProgressRequestType =
  Requestify<GetLessonProgressRequest>;
export type GetUserLessonProgressResponseType = LessonContentProgressResponse;
export type GetUserLessonProgressErrorType = UserProgressReadError &
  HubspotMetadata;
export const getUserLessonProgressRpc: ChirpAvroRpcDetails<
  GetUserLessonProgressRequestType,
  GetUserLessonProgressResponseType,
  GetUserLessonProgressErrorType,
  false
> = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserLessonProgress',
  auth: 'app',
  fingerprint: '5s9xr8DEgluEsVhuWrGNMAxMK10-h47i',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUserTrackProgressRequestType =
  Requestify<GetTrackProgressRequest>;
export type GetUserTrackProgressResponseType = TrackContentProgressResponse;
export type GetUserTrackProgressErrorType = UserProgressReadError &
  HubspotMetadata;
export const getUserTrackProgressRpc: ChirpAvroRpcDetails<
  GetUserTrackProgressRequestType,
  GetUserTrackProgressResponseType,
  GetUserTrackProgressErrorType,
  false
> = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserTrackProgress',
  auth: 'app',
  fingerprint: 'HW3JR86f2stnSvuDm1uDtQxMK10-h47i',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAllUserProgressByUserIdRequestType =
  Requestify<GetUserProgressRequest>;
export type GetAllUserProgressByUserIdResponseType =
  AcademyUserProgressV2Response;
export type GetAllUserProgressByUserIdErrorType = UserProgressReadError &
  HubspotMetadata;
export const getAllUserProgressByUserIdRpc: ChirpAvroRpcDetails<
  GetAllUserProgressByUserIdRequestType,
  GetAllUserProgressByUserIdResponseType,
  GetAllUserProgressByUserIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getAllUserProgressByUserId',
  auth: 'app',
  fingerprint: 'YBIXzl6izPd0pv7BTTvW7QxMK10-h47i',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
